import { Action, createReducer, on } from '@ngrx/store';

import { setDsHeaderConfigAction } from '@header/store/actions/header.actions';
import { DsHeaderConfig } from '@header/entities/ds-header-config';

export const initialState = {
  type: null,
  titleKey: null,
  pageType: null,
};

const reducer = createReducer(
  initialState,
  on(setDsHeaderConfigAction, (state, { config }) => config)
);

export function dsHeaderConfigReducer(state: DsHeaderConfig, action: Action): DsHeaderConfig {
  return reducer(state, action);
}
